import { useTranslation } from 'react-i18next'

import { EMPTY_OBJECT } from '../../../../../constants/common'
import Button from '../../../../Button'
import Text from '../../../../Text'

import * as styles from './RequestBoardColumnMessage.module.css'

function RequestBoardColumnMessage({
  actionProps: { textKey: actionTextKey, ...actionProps } = EMPTY_OBJECT,
  textKey,
}) {
  const { t } = useTranslation()

  return (
    <div className={styles.RequestBoardColumnMessage}>
      <Text isSecondary>{t(textKey)}</Text>
      {actionTextKey ? (
        <Button.Text
          {...actionProps}
          className={styles.action}
          text={t(actionTextKey)}
        />
      ) : null}
    </div>
  )
}

export default RequestBoardColumnMessage
